var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.isLoading ? _c('loading') : [_c('div', {
    staticClass: "rooms border-right"
  }, [_c('header', {
    staticClass: "d-flex justify-content-between align-items-center sticky-top"
  }, [_c('span', {
    staticClass: "text-left d-sm-none"
  }), _c('h1', {
    staticClass: "px-3"
  }, [_vm._v("訊息中心")]), _c('span', {
    staticClass: "text-right"
  })]), _c('div', {
    staticClass: "px-3 pt-3 pb-2"
  }, [_c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('div', {
    staticClass: "search flex-grow-1"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "d": "M500.3 443.7l-119.7-119.7c27.22-40.41 40.65-90.9 33.46-144.7C401.8 87.79 326.8 13.32 235.2 1.723C99.01-15.51-15.51 99.01 1.724 235.2c11.6 91.64 86.08 166.7 177.6 178.9c53.8 7.189 104.3-6.236 144.7-33.46l119.7 119.7c15.62 15.62 40.95 15.62 56.57 0C515.9 484.7 515.9 459.3 500.3 443.7zM79.1 208c0-70.58 57.42-128 128-128s128 57.42 128 128c0 70.58-57.42 128-128 128S79.1 278.6 79.1 208z"
    }
  })]), _c('b-form-input', {
    attrs: {
      "type": "search",
      "placeholder": "姓名搜尋"
    },
    on: {
      "input": _vm.keywordSearchDebounced
    },
    model: {
      value: _vm.keyword,
      callback: function callback($$v) {
        _vm.keyword = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "keyword"
    }
  })], 1), _vm.allowFilterStatus ? _c('div', {
    staticClass: "status-filter ml-2"
  }, [_c('ChatroomMultiselect', {
    attrs: {
      "title": "處理狀態",
      "filters": _vm.statusOptions,
      "showKeywordFilter": false,
      "selectedOptions": _vm.selectedStatus
    },
    on: {
      "click": _vm.handleSelectedStatus
    }
  })], 1) : _vm._e()]), _vm.allowFilterStatus && _vm.selectedStatus.length ? _c('div', {
    staticClass: "d-flex flex-wrap align-items-center mb-2"
  }, _vm._l(_vm.selectedStatus, function (s) {
    return _c('b-badge', {
      key: s.value,
      staticClass: "mr-1 mb-1",
      attrs: {
        "variant": s.variant,
        "role": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.handleSelectedStatus(s);
        }
      }
    }, [_vm._v(" " + _vm._s(s.text) + " ✕ ")]);
  }), 1) : _vm._e()]), _c('b-list-group', [_vm.filteredChatrooms.length > 0 ? _vm._l(_vm.filteredChatrooms, function (i) {
    return _c('b-list-group-item', {
      key: i.id,
      staticClass: "d-flex align-items-center position-relative",
      attrs: {
        "role": "button",
        "variant": _vm.chatroomId == i.id ? 'secondary' : 'default'
      },
      on: {
        "click": function click($event) {
          return _vm.handleLink(i.id);
        }
      }
    }, [_vm.isPinned(i) ? _c('span', {
      staticClass: "pinned"
    }, [_c('i', {
      staticClass: "fa fa-thumb-tack text-warning",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e(), [_c('b-avatar', {
      staticClass: "mr-3",
      attrs: {
        "src": _vm.getChatroomAvatar(i)
      }
    }), _c('div', {
      staticClass: "mr-auto font-weight-bold"
    }, [_vm._v(" " + _vm._s(_vm.resolveTitle(i)) + " "), _c('div', {
      staticClass: "text-muted small"
    }, [_vm._v(" " + _vm._s(_vm.getChatroomLastMessage(i)) + " ")])])], i.is_new_created || i.is_new ? _c('b-badge', {
      attrs: {
        "pill": "",
        "variant": "outline-info"
      }
    }, [_vm._v(" New ")]) : _vm._e(), i.unread > 0 ? _c('b-badge', {
      attrs: {
        "pill": "",
        "variant": "primary"
      }
    }, [_vm._v(_vm._s(i.unread))]) : _vm._e(), !i.is_new_created && !i.is_new && !(i.unread > 0) ? _c('span', {
      staticClass: "text-muted small"
    }, [_vm._v(" " + _vm._s(_vm.formatDate(i.updated_at)) + " ")]) : _vm._e()], 2);
  }) : _c('b-list-group-item', {
    staticClass: "empty"
  }, [_c('img', {
    attrs: {
      "src": require("./images/empty.svg")
    }
  }), _c('div', {
    staticClass: "mt-3 text-dark small"
  }, [_vm._v("目前沒有名單")])])], 2), _c('Pagination', {
    attrs: {
      "total-page": _vm.meta.lastPage
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1), _vm.chatroomId ? _c('div', {
    staticClass: "flex-grow-1 d-none d-sm-block"
  }, [_c('Chatbox', {
    key: _vm.chatroomId,
    attrs: {
      "chatroomId": _vm.chatroomId
    }
  })], 1) : _c('div', {
    staticClass: "\n        empty-chat\n        d-none d-sm-flex\n        justify-content-center\n        align-items-center\n      "
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": require("./images/empty_chat.svg")
    }
  }), _c('div', {
    staticClass: "mt-3 text-dark small"
  }, [_vm._v("選一位客戶開始一段對話吧")])])])]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }